// extracted by mini-css-extract-plugin
export default {"deleteIcon":"OtherIdentityInfo_deleteIcon__tS8f3"};